package ru.it_mozaika.utils

import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.*
import ru.it_mozaika.sender.common.models.User


object UserApi : Api() {
    private const val API_URL: String = "/accounts"

    suspend fun getUser(): User? {
        val response = get(API_URL)
        return if (response.status.isSuccess()) {
            response.body()
        } else {
            null
        }
    }

    fun getUser(callback: (User?) -> Unit) {
        asyncGet(API_URL) { response ->
            callback(if (response.status.isSuccess() && response.contentType() == ContentType.Application.Json) {
                response.body()
            } else {
                null
            })
        }
    }

    fun logout(callback: () -> Unit) {
        asyncGet("/accounts/logout") {
            callback()
        }
    }

}